<template>
    <v-text-field type="time" :rules="rules" variant="outlined" v-model="modelValue">
    </v-text-field>
</template>

<script setup>
import { defineModel, defineProps } from "vue"
const modelValue = defineModel({
    required: true,
    type: String
})
const props = defineProps({
    required: {
        type: Boolean,
        default: () => {
            return false
        },
        required: false
    },

})
const rules = [
    (v) => {
        return !props.required || !!v || "Silahkan isi bagian ini"
    }
]
</script>

<style lang="scss" scoped></style>